import { Box, Chip, Paper, Stack, Typography } from '@mui/material'
import { capitalize } from 'lodash'
import Header from 'components/Header'

const TYPE_COLORS = { student: 'primary', staff: 'secondary', parent: 'success' }

const AccessCard = ({ primary, secondary, tertiary }) => (
  <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
    <Typography fontWeight={600}>{primary}</Typography>
    {secondary && <Typography variant="body2" color="text.secondary" mt={0.5}>{secondary}</Typography>}
    {tertiary && <Typography variant="body2" color="text.secondary">{tertiary}</Typography>}
  </Paper>
)

const renderCard = (type, view, i) => {
  if (type === 'parent') {
    const student = view.schoolEnrollment?.person
    return (
      <AccessCard
        key={i}
        primary={student ? `${student.lastName}, ${student.firstName}` : '—'}
        secondary={view.campusName}
        tertiary={view.academicYearEnrollment ? `Grade Section: ${view?.academicYearEnrollment?.section?.gradeSection}` : null}
      />
    )
  }

  if (type === 'student') {
    return (
      <AccessCard
        key={i}
        primary={view.campusName || '—'}
        tertiary={view.academicYearEnrollment ? `Grade Section: ${view?.academicYearEnrollment?.section?.gradeSection}` : null}
      />
    )
  }

  return <AccessCard key={i} primary={view.campusName || '—'} />
}

export default function LookupDetail({ person, onClose }) {
  const views = person.personAccessViews ?? []

  return (
    <Box>
      <Header
        title={`${person.lastName}, ${person.firstName}`}
        subtitle={<Chip label={capitalize(person.type)} color={TYPE_COLORS[person.type] ?? 'default'} size="small" />}
        close={onClose}
        borderBottom
        small
      />
      <Box sx={{ p: 2 }}>
        {views.length === 0 ? (
          <Typography color="text.secondary">No active enrollments</Typography>
        ) : (
          <Stack spacing={1.5}>
            {views.map((view, i) => renderCard(person.type, view, i))}
          </Stack>
        )}
      </Box>
    </Box>
  )
}
